import { render, staticRenderFns } from "./PageComponent.vue?vue&type=template&id=9563ff0c&"
import script from "./PageComponent.vue?vue&type=script&lang=js&"
export * from "./PageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports